import React from 'react'
import Helmet from 'react-helmet'
import { config } from 'config'
import _ from 'lodash'
import { Container, Grid, Breakpoint, Span } from 'react-responsive-grid'
import { rhythm } from 'utils/typography'
import PortfolioHead from 'components/PortfolioHead'
import PortfolioIntroBanner from 'components/PortfolioIntroBanner'
import PortfolioNextPrevLink from 'components/PortfolioNextPrevLink'
import works from 'data/works'
import { findWork } from 'data/works-helper'
import Gallery from 'components/Gallery'

export default class ReactComponent extends React.Component {

  prefixPath(fileName) {
    return this.props.route.page.path + fileName;
  }

  render () {
    this.galleries = [
      [
        {src: this.prefixPath('landing.jpg'), caption: 'Landing Page'},
        {src: this.prefixPath('mockup-02.jpg'), caption: 'Modules directory'},
        {src: this.prefixPath('mockup-03.jpg'), caption: 'Module details'},
        {src: this.prefixPath('mockup-04.jpg'), caption: 'Modules directory (mobile)'},
        {src: this.prefixPath('mockup-05.jpg'), caption: 'Modules directory (mobile)'},
        {src: this.prefixPath('mockup-06.jpg'), caption: 'Modules detail (mobile)'}
      ]
    ];

    this.galleries[0] = this.galleries[0].map((v, i) => {
      v.index = i;
      return v;
    });

    const data = findWork(works, this.props.route.page.path);
    console.log(data);

    return (
      <div>
        <Helmet
          title={`${config.siteTitle} | ${data.name}`} 
        />
        <PortfolioHead data={data} />
        <Container
            style={{
              maxWidth: 960,
              paddingTop: 0,
              padding: `${rhythm(1)} ${rhythm(3/4)}`,
            }}
          >

          <div className="section">
            <div className="section-header">
              <PortfolioNextPrevLink data={data} />
              <h2>Description</h2>
            </div>
            <p>
              Inline is an integration hub for LINE. It lets developers easily integrate their apps and services into users' conversations. Inline makes programmatic connections between LINE and other apps possible, for example, receiving Fitbit notifications in LINE conversations and turning off your lights at home by typing into LINE. 
            </p>

            <br />
            <p>
              In April 2016, I worked with Rollables team to demonstrate our idea at the first LINE Hackathon in Thailand. 
              I composed pre-hackathon pitch deck and worked as the team’s designer. 
              I formed official account (chatbot) interaction patterns and designed the integrations directory portal.
            </p>
            <br />

            <p>
              Inline have won the first runner-up prize at the competition. 
              Our idea was recognized by the jury to coincide with LINE long-term vision of becoming the hub for inter-app communications. 
              Sharing the same vision, LINE had been internally developing <a href="https://notify-bot.line.me/en/">LINE Notify</a> which was launched after the hackathon in mid-2016.
            </p>
            <br />
            
          </div>

          <div className="section center">
            <p>Demo video</p>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/rg8979TPChE" frameBorder="0" allowfullscreen></iframe>
          </div>

          <div className="section">
            
            <h3>Software Architecture</h3>
            <p>
            Technically, our team has demonstrated a module based architecture where developers could submit a module from their repository to implement a command in Inline. It looks like the following.
            </p>
            <br />
            
            <img src={this.prefixPath('inline-architecture.jpg')} />
            <br /><br />
            <h3>User Experience</h3>
            <p>We aim for a wholistic experience where users does not need to exit LINE in order to complete their tasks. 
            INLINE service run as an official account (Facebook Page in LINE terms).
            </p>
            <img src={this.prefixPath('inline-ux-steps.jpg')} />
          </div>

          <br />

          <div className="section center">
            <p>User interface mockups</p>
            <br />
            <Gallery images={this.galleries[0]} />
          </div>

          <div className="section">
            <div className="section-header">
              <h2>Contributors</h2>
            </div>
            <ul>
              <li>Komthep Saksriyuttana (Front-end Developer)</li>
              <li>Natthakit Susanthitanon (Fullstack Developer)</li>
              <li>Panjamapong Sermsawatsri (Back-end, IoT Developer)</li>
              <li>Soravis Prakkamakul (UX/UI Designer)</li>
              <li>Sarawoot Piya-arayanunt (Fullstack Developer)</li>
            </ul>
          </div>
          <div className="section">
            <PortfolioNextPrevLink data={data} />
          </div>
        </Container>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./works/inline-at-line-hack/index.jsx
 **/